export type GUID = string & { isGuid: true};
export function guid(guid: string) : GUID {
    return  guid as GUID; 
}

export interface AssignUser {
    name : string ,
    firstName : string,
    lastName : string
    userId : string,
    status? : number,
    roleId? : number,
    isActive : boolean,
    selectedUser: any
}